<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span @click="resetSingleSidebarFilter(name)" title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <export-options
        :exportUrl="exportUrl"
        :repository="repository"
        :resource="resource"
        :tableRef="$refs[tableRef]"
        :filter="filter"
        :options="[
          {
            code: 'EXCOGICO',
            label: null,
            formats: ['csv', 'pdf'],
          },
        ]"
      ></export-options>
    </actions-toolbar>

    <b-sidebar
      id="sidebar-1"
      :title="computedFilterTitle"
      :backdrop="true"
      width="50dvw"
      shadow
      right
      :visible="open_filter"
      :data-open="open_filter"
      @change="onSidebarFilterChange"
    >
      <b-form @submit.prevent="onSearch(filterName)">
        <div class="filter">
          <div class="filter-item">
            <base-select
              name="conto"
              label="Codice del Conto"
              :options="treasuries_opt"
              v-model="filter.conto"
            />
          </div>
          <div class="filter-item" data-cols="2">
            <base-datepicker
              name="a_partire_dal"
              label="Dal"
              v-model="filter.a_partire_dal"
            />
            <base-datepicker
              name="fino_al"
              label="Al"
              v-model="filter.fino_al"
            />
          </div>
          <div class="filter-item">
            <base-select
              name="produttore"
              label="Produttore"
              :options="salesmen_select"
              v-model="filter.produttore"
              :multiple="true"
              :taggable="salesmen_taggable"
              :closeOnSelect="false"
              :defaultHtmlMultipleSelect="true"
              @changeTaggable="changeTaggable"
            >
              <template #advanced-actions>
                <b-button
                  :pressed.sync="myToggle"
                  variant="light"
                  class="btn--x-smaller btn--smaller btn--transparent"
                  @click="myToggle ? selectAllSalesmen() : deselectAllSalesmen()"
                  >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                </b-button>
                <b-button
                  :pressed.sync="myTogglePO"
                  variant="light"
                  class="btn--smaller btn--x-smaller btn--transparent"
                  @click="
                    myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                  "
                  >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                </b-button>
              </template>
            </base-select>
          </div>
          <div class="filter-item">
            <base-select
              name="causale"
              label="Causale"
              :options="cash_references_opt"
              v-model="filter.causale"
            />
          </div>
          <div class="filter-item">
            <base-select
              name="insurers"
              label="Compagnie"
              :options="companies"
              :taggable="true"
              :multiple="true"
              :closeOnSelect="false"
              v-model="filter.compagnia"
            />
          </div>
          <div class="filter-item" data-cols="2">
            <base-select
              name="foglio_cassa_compagnia"
              label="Foglio Cassa Compagnia"
              :options="[
                { value: '1', text: 'Si' },
                { value: '0', text: 'No' },
              ]"
              v-model="filter.foglio_cassa_compagnia"
            />
            <base-select
              name="cassa_agenzia"
              label="Controllo di Cassa"
              :options="[
                { value: '1', text: 'Si' },
                { value: '0', text: 'No' },
              ]"
              v-model="filter.cassa_agenzia"
            />
          </div>
        </div>
        <div class="actions-filter-sidebar-wrapper">
          <b-button
            type="submit"
            variant="lisaweb"
            size="sm"
            v-b-toggle:sidebar-1
            >Cerca
          </b-button>
          <b-button
            class="btn--transparent btn-reset"
            type="button"
            size="sm"
            @click="onClearFilter(filterName)"
            >Reset
          </b-button>
        </div>
      </b-form>
    </b-sidebar>
    <exp-cash-entries-table
      :fields="fields"
      :repository="repository"
      :resource="resource"
      @manualFetch="manualFetch"
      :performedSearch="computePerformedSearch"
      :filterCount="countActiveFilters"
      :filterName="filterName"
      :filterOn="{
        byRelations: ['byBroker', 'byTreasury', 'byCashReference'],
      }"
      :ref="tableRef"
      :previous_balance_date="previous_balance_date"
      :previous_balance="previous_balance"
      :current_balance_date="filter.fino_al"
      :current_balance="current_balance"
      type="exp-cash-entry"
      noActions
    ></exp-cash-entries-table>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
// import CashEntriesTable from "@/components/tables/CashEntry.vue";
import ExpCashEntriesTable from "@/components/tables/ExpCashEntry.vue";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { mapActions, mapGetters } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import { toLocaleCurrency } from "@/utils/strings";
import { today } from "@/utils/dates";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import ExportOptions from "@/components/ExportOptions";
import moment from "moment";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

moment.locale("it");

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      repository: "cash_entry",
      resource: "movimenti_prima_nota",
      tableRef: "CashEntriesExportTableRef",
      filterName: "filterCashEntriesExport",
      cash_references_opt: [],
      treasuries_opt: [],
      companies: [],
      myToggle: false,
      myTogglePO: false,
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_taggable: true,
      performedSearch: false,
      activeFilters: {},
      filter: this.initFilter(),
      previous_balance_date: null,
      previous_balance: {},
      current_balance: {},
      fields: [
        {
          key: "conto.codice",
          label: this.getDictionary("Conto"),
        },
        {
          key: "data_registrazione",
          formatter: (value) => toLocaleDate(value),
          label: this.getDictionary("cash_time", "cash_entry"),
        },
        {
          key: "produttore.title",
          label: this.getDictionary("salesman"),
        },
        {
          key: "causale",
          label: this.getDictionary("cash_reference_id", "cash_entry"),
          formatter: (value) => `${value.codice} - ${value.descrizione}`,
        },
        {
          key: "descrizione",
          label: this.getDictionary("title", "cash_entry"),
        },
        {
          key: "id_compagnia",
          label: "Compagnia",
          formatter: (value) => this.retriveInsurer(value),
        },
        {
          key: "entrate",
          formatter: (value, field, item) => {
            if (item?.causale?.tipo_di_movimento === 0)
              return toLocaleCurrency(Math.abs(parseFloat(item.importo)));
            return "";
          },
          label: this.getDictionary("entry_in", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
        },
        {
          key: "uscite",
          formatter: (value, field, item) => {
            if (item?.causale?.tipo_di_movimento === 1)
              return toLocaleCurrency(Math.abs(parseFloat(item.importo)));
            return "";
          },
          label: this.getDictionary("entry_out", "cash_entry"),
          tdClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
        },
      ],
    };
  },
  components: {
    BaseIcon,
    // CashEntriesTable,
    ExpCashEntriesTable,
    BaseSelect,
    BaseDatepicker,
    ExportOptions,
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  methods: {
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllSalesmen() {
      this.filter.produttore = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllSalesmen() {
      this.filter.produttore = [];
      this.salesman_id = null;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.exportUrl = null;
      this.previous_balance_date = null;
      this.previous_balance = {};
      this.current_balance = {};
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    retriveInsurer(value) {
      let insurer_text = "";
      this.companies.forEach((company) => {
        if (company.value === value) insurer_text = company.text;
      });
      return insurer_text;
    },
    initFilter() {
      let init = {
        a_partire_dal: today(),
        fino_al: today(),
        produttore: null,
        causale: null,
        conto: null,
        compagnia: [],
        foglio_cassa_compagnia: null,
        cassa_agenzia: null,
      };
      return init;
    },
    // customFilterName(key, prefix = "byAttribute") {
    //   return `${prefix}.${key}`;
    // },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      // this.$refs[this.tableRef].sortBy = "data_registrazione";
      // this.$refs[this.tableRef].sortAsc = true;
      this.fetch();
    },
    fetch(name) {
      if (
        this.filter.fino_al &&
        this.filter.conto &&
        this.filter.a_partire_dal
      ) {
        let criteria = this.filter;
        this.saveFilterByName({ name, criteria });
        this.removePaginationByName(name);
        return this.$refs[this.tableRef]
          .fetch({ verb: { name: "listaMovimenti", alias: "index" } })
          .then(() => {
            this.fetchSummary();
          });
      } else {
        this.$showSnackbar({
          preset: "success",
          text: `Devi impostare i campi 'data al', 'data a' e 'codice del conto'`,
        });
      }
    },
    fetchSummary() {
      this.$refs[this.tableRef].isLoading = true;
      const Repo = RepositoryFactory.get(this.repository);
      // Previous Balance
      this.previous_balance_date = moment(this.filter.a_partire_dal)
        .subtract(1, "d")
        .format("YYYY-MM-DD");
      const byBroker = this.filter.produttore
        ? `&produttore=${this.filter.produttore}`
        : "";
      const byCashReference = this.filter.causale
        ? `&causale=${this.filter.causale}`
        : "";
      const queryString = `fino_al=${this.previous_balance_date}&conto=${this.filter.conto}${byBroker}${byCashReference}`;
      Repo.summary(queryString)
        .then((response) => {
          this.previous_balance = response.data;
          // Current Balance
          const queryString = `a_partire_dal=${this.filter.a_partire_dal}&fino_al=${this.filter.fino_al}&conto=${this.filter.conto}${byBroker}${byCashReference}`;
          Repo.summary(queryString)
            .then((response) => {
              this.current_balance = response.data;
              this.$refs[this.tableRef].isLoading = false;
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
              this.$refs[this.tableRef].isLoading = false;
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.$refs[this.tableRef].isLoading = false;
        });
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getInsurers: "insurers",
      getCashReferences: "cash_references",
      getContiPrimaNota: "allContiPrimaNota",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("insurers")) {
      resources.push(
        this.$store
          .dispatch(`${path}insurers`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.companies = this.getInsurers();
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.companies = this.getInsurers();
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    /* */
    let cashReferences = this.getCashReferences();
    cashReferences.sort((a, b) => a.text - b.text);
    cashReferences.forEach((el) => {
      this.cash_references_opt.push({
        text: `${el.text} - ${el.description}`,
        reference_type: el.reference_type,
        has_broker: el.has_broker,
        has_company: el.has_company,
        entry_type: el.entry_type,
        value: el.value,
        treasury_id: el.treasury_id,
      });
    });
    /* */
    this.treasuries_opt = this.getContiPrimaNota();
  },
  beforeMount() {
    this.removeFilterByName(this.filterName);
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
  },
};
</script>
